import { useState, useCallback } from 'react';
import { Position as CustomPosition } from '../types/depth-chart';

interface ModalState {
  showDepthStringManager: boolean;
  showCustomFormationBuilder: boolean;
  editingCustomFormation: {name: string, positions: CustomPosition[]} | null;
  editingFormationId: string | null;
}

interface UseDepthChartModalsReturn extends ModalState {
  openDepthStringManager: () => void;
  closeDepthStringManager: () => void;
  openCustomFormationBuilder: () => void;
  closeCustomFormationBuilder: () => void;
  setEditingCustomFormation: (formation: {name: string, positions: CustomPosition[]} | null) => void;
  setEditingFormationId: (id: string | null) => void;
  closeAllModals: () => void;
}

export const useDepthChartModals = (): UseDepthChartModalsReturn => {
  const [showDepthStringManager, setShowDepthStringManager] = useState(false);
  const [showCustomFormationBuilder, setShowCustomFormationBuilder] = useState(false);
  const [editingCustomFormation, setEditingCustomFormation] = useState<{name: string, positions: CustomPosition[]} | null>(null);
  const [editingFormationId, setEditingFormationId] = useState<string | null>(null);

  const openDepthStringManager = useCallback(() => {
    setShowDepthStringManager(true);
  }, []);

  const closeDepthStringManager = useCallback(() => {
    setShowDepthStringManager(false);
  }, []);

  const openCustomFormationBuilder = useCallback(() => {
    setShowCustomFormationBuilder(true);
  }, []);

  const closeCustomFormationBuilder = useCallback(() => {
    setShowCustomFormationBuilder(false);
    setEditingCustomFormation(null);
    setEditingFormationId(null);
  }, []);

  const closeAllModals = useCallback(() => {
    setShowDepthStringManager(false);
    setShowCustomFormationBuilder(false);
    setEditingCustomFormation(null);
    setEditingFormationId(null);
  }, []);

  return {
    showDepthStringManager,
    showCustomFormationBuilder,
    editingCustomFormation,
    editingFormationId,
    openDepthStringManager,
    closeDepthStringManager,
    openCustomFormationBuilder,
    closeCustomFormationBuilder,
    setEditingCustomFormation,
    setEditingFormationId,
    closeAllModals
  };
};